import { Revision } from 'types'
import {
  Options,
  Variables as CreateRevisionVariables,
  useCreateRevision,
} from 'hooks/queries/layers/revisions/useCreateRevision'

interface Props {
  revision: Revision
}

export interface Variables extends Omit<CreateRevisionVariables, 'prompt' | 'previousRevisionId'> {}

export const useRetryRevision = ({ revision }: Props, options?: Options) => {
  const { mutate, mutateAsync, ...mutationResult } = useCreateRevision(
    { articleKey: revision.layer.article_id, layerId: revision.layer.id },
    options,
  )
  const retry = (variables: Variables) =>
    mutate({
      ...variables,
      previousRevisionId: revision.previous_revision?.id,
      prompt: revision.prompt,
    })
  const retryAsync = (variables: Variables) =>
    mutateAsync({
      ...variables,
      previousRevisionId: revision.previous_revision?.id,
      prompt: revision.prompt,
    })
  return { ...mutationResult, retry, retryAsync }
}
